import React, { useState, useEffect } from "react";
import "./Adminprofile.css";
import { useDispatch, useSelector } from "react-redux";
import default_pfp from "../../../images/default_pfp.svg";
import { fetchProfileData } from "../../../Services/Profile/ProfileApi";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { capitalizeFirstLetter } from "../../../Utils/LetterCase";

function AdminprofileComp() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.fetchProfileData);
  const [profile, setProfile] = useState({});
  const [userEmail, setUserEmail] = useState();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchProfileData(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    if (data) {
      setProfile(data?.data);
      setUserEmail(data?.data?.email);
    }
  }, [data]);

  const handleSendEmail = () => {
    if (data) {
      navigate(`/change-password?email=${encodeURIComponent(userEmail)}`); // Pass email as a query parameter
    }
  };

  const handleUpdateProfile = () => {
    navigate("/admin/update-profile", { state: { profileData: profile } });
  };

  return (
    <div className="admin-profile-section">
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="admin-profile-wrapper">
        <div className="admin-profile-inner">
          <div className="admin-content-block d-flex">
            <div className="admin-pic-name">
              <div className="admin-img">
                <img
                  src={profile?.image || default_pfp}
                  alt="Profile-picture"
                  onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop
                    e.target.src = default_pfp; // Fallback image
                  }}
                />
              </div>
              <div className="admin-name text-center">
                {capitalizeFirstLetter(profile?.first_name)} {capitalizeFirstLetter(profile?.last_name)}
              </div>
              <div className="admin-designation text-center">{userType}</div>
            </div>
            <div className="admin-main-details">
              <div className="personal-details">Personal Details</div>
              <div className="table-admin">
                <div className="table-admin-inner">
                  <table className="table table-borderless table-desktop-view">
                    <thead>
                      <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Email address</th>
                        <th scope="col">Phone Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{capitalizeFirstLetter(profile?.first_name)}</td>
                        <td>{capitalizeFirstLetter(profile?.last_name)}</td>
                        <td>{profile?.email}</td>
                        <td>{profile?.phone_number}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table table-borderless table-mobile-view">
                    <tbody>
                      <tr className="d-grid row-superadmin">
                        <td>{capitalizeFirstLetter(profile?.first_name)}</td>
                        <td>{capitalizeFirstLetter(profile?.last_name)}</td>
                        <td>{profile?.email}</td>
                        <td className="ph_number">{profile?.phone_number}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="change-edit-btns d-flex gap-3 justify-content-end ">
            <div className="change-pw-btn text-end mt-3">
              <button onClick={handleSendEmail}>Change Password</button>
            </div>
            <div className="editprofile-btn text-end mt-3">
              <button onClick={handleUpdateProfile}>Edit Profile</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminprofileComp;
